<template lang="pug">
  section(class="mb-7")
    v-row(no-gutters)
      v-col(cols=12 class="main-block")
        v-row(justify="center")
          h1(class="main-title") {{ $t('title') }}
        v-row(justify="space-between" align="center" style="padding:0 80px;")
          div(class="main-filters")
            v-row(no-gutters justify="start" align="center")
              v-select(
                solo
                dense
                v-model="filters.items.Type"
                :items="advertItems",
                item-text="text"
                item-value="id"
                class="advert select-type")
              v-text-field(
                solo
                dense
                v-model="filters.items.PriceFrom"
                placeholder="цена от"
                class="price select-type")
              div(class="line") #[b -]
              v-text-field(
                solo
                dense
                v-model="filters.items.PriceTo"
                placeholder="цена до"
                class="price select-type")
              v-select(
                solo
                dense
                v-model="filters.items.Currency"
                :items="currencyList"
                item-value="key"
                item-text="text"
                class="currency select-type")
          div
            v-btn(@click.prevent="onClickViewMapBtn")
              v-img(:src="require('@/assets/images/icons/pin.svg')" class="mr-2")
              span {{ $t('button.map') }}
          div
            v-btn(
              color="#0091FF",
              dark,
              @click.prevent="onClickViewListBtn").
                {{ $t('button.adverts', {count: countAdverts}) }}
</template>
<script>
export default {
  data: () => ({
    type: 'rent',
    filters: {},
    advertItems: [
      {
        id: 'apartment',
        text: 'Снять квартиру'
      },
      {
        id: 'room',
        text: 'Снять комнату'
      },
      {
        id: 'house',
        text: 'Снять дом'
      },
      {
        id: 'area',
        text: 'Снять участок'
      }
    ]
  }),
  created() {
    this.filters = { ...this.baseFilters }
  },
  watch: {
    filters: {
      deep: true,
      handler(values) {
        const filters = JSON.parse(localStorage.filters)
        filters.advertType = this.setAdvertsType(values.items.Type)
        filters.items.Type = values.items.Type
        filters.items.PriceFrom = values.items.PriceFrom
        filters.items.PriceTo = values.items.PriceTo
        filters.items.Currency = values.items.Currency
        localStorage.filters = JSON.stringify(filters)
        this.$store.dispatch('GET_ADVERTS_FILTER_COUNT')
      }
    }
  },
  computed: {
    baseFilters() {
      return this.$store.state.baseFilters
    },
    countAdverts() {
      return this.$store.state.countAdverts
    },
    currencyList() {
      return this.$store.state.currencyList
    }
  },
  methods: {
    setAdvertsType(value) {
      if (this.type === 'rent') {
        switch (value) {
          case 'apartment':
            return 'RentApartment'
          case 'room':
            return 'RentRoom'
          case 'house':
            return 'RentHouse'
          case 'area':
            return 'RentArea'
          case 'other':
            return 'RentOther'
        }
      } else if (this.type === 'sale') {
        switch (value) {
          case 'apartment':
            return 'SellApartment'
          case 'room':
            return 'SellRoom'
          case 'house':
            return 'SellHouse'
          case 'area':
            return 'SellArea'
          case 'other':
            return 'SellOther'
        }
      }
    },
    onClickViewMapBtn() {
      this.$store.commit('SET_VIEW_TYPE', 'map')
      this.$router.push({ path: '/advert/list/rent' })
    },
    onClickViewListBtn() {
      this.$store.commit('SET_VIEW_TYPE', 'list')
      this.$router.push({ path: '/advert/list/rent' })
    }
  }
}
</script>
<style lang="scss">
.main {
  &-title {
    font-size: 26px;
    line-height: 35px;
    letter-spacing: -0.361111px;
    color: #ffffff;
    padding: 40px 0 36px 0;
  }
  &-block {
    border-radius: 6px;
    height: 337px;
    background: url('../../assets/images/main-page.jpg') no-repeat center;
    background-size: cover;
  }
  &-filters {
    background: white;
    border-radius: 4px;
    .select-type {
      .v-select__selection {
        font-size: 12px;
        color: #333;
      }
      .v-input__slot {
        margin: 0;
        border: transparent !important;
        &:before {
          display: none;
        }
      }
      .v-text-field__details {
        display: none;
      }
    }
    .advert {
      margin: 0;
      padding: 0;
      max-width: 160px;
    }
    .currency {
      margin: 0;
      padding: 0;
      max-width: 80px;
    }
    .price {
      margin: 0;
      padding: 0;
      max-width: 80px;
      input {
        font-size: 12px;
        color: #333 !important;
      }
    }
    .line {
      max-width: 30px;
      margin: 0;
    }
  }
}
</style>
